import moment from "moment";
import SvgIcon from "./SvgIcon";

const MonthController = ({ date, setDate, mobile }) => {
  const handleDate = (operation, amount, type) => {
    if (operation === "subtract") {
      setDate(moment(date).subtract(amount, type));
    } else {
      setDate(moment(date).add(amount, type));
    }
  };
  return (
    <div role="month-handler">
      <button
        data-button-type="secondary"
        data-icon-only
        onClick={() => handleDate("subtract", 1, mobile ? "month" : "year")}
      >
        <SvgIcon src="/img/new-icons/double-arrow-left.svg" />
      </button>
      <div>
        <button
          data-button-type="text-white"
          data-icon-only
          onClick={() => handleDate("subtract", 1, mobile ? "week" : "month")}
        >
          <SvgIcon src="/img/new-icons/arrow-left.svg" />
        </button>
        <span>{moment(date).format("MMM YYYY")}</span>
        <button
          data-button-type="text-white"
          data-icon-only
          onClick={() => handleDate("add", 1, mobile ? "week" : "month")}
        >
          <SvgIcon src="/img/new-icons/arrow-right.svg" />
        </button>
      </div>
      <button
        data-button-type="secondary"
        data-icon-only
        onClick={() => handleDate("add", 1, mobile ? "month" : "year")}
      >
        <SvgIcon src="/img/new-icons/double-arrow-right.svg" />
      </button>
    </div>
  );
};

export default MonthController;
